import * as yup from "yup";

export const schema = yup.object().shape({
  id: yup.number().notRequired(),
  price: yup.number().required().moreThan(0),
  cycle: yup.string().required(),
  plan_id: yup.number().required(),
});
